import a from "react";
function f(t) {
  return t.replace(/-([a-z])/g, (o) => o[1].toUpperCase());
}
function w(t) {
  return t.split(";").reduce((o, s) => {
    let [r, n] = s.split(":");
    return r = r == null ? void 0 : r.trim(), n = n == null ? void 0 : n.trim(), r && n && (o[f(r)] = n), o;
  }, {});
}
function d(t) {
  if (Array.isArray(t))
    return t.map((e) => d(e));
  const o = {
    class: "className",
    for: "htmlFor",
    targetAttr: "targetattr"
    // Add more attribute conversions here as needed
  }, s = Object.keys(t.props).reduce((e, i) => {
    let p = t.props[i];
    i === "style" && typeof p == "string" && (p = w(p));
    const u = o[i] || i;
    return e[u] = p, e;
  }, {});
  s.key = t.key;
  const r = a.Children.map(t.props.children, (e) => typeof e == "string" ? e : d(e));
  return a.createElement(t.type, s, r);
}
const c = () => typeof window < "u", m = () => typeof window > "u", g = () => c() && typeof window.storyblokRegisterEvent < "u", l = () => c() && window.self !== window.top, E = () => c() && l() && window.location.search.includes("_storyblok");
export {
  d as convertAttributesInElement,
  g as isBridgeLoaded,
  c as isBrowser,
  l as isIframe,
  m as isServer,
  E as isVisualEditor
};
